import type { FunctionComponent } from 'react';

import { Field } from '@kanda-libs/ks-component-ts';
import { Button, Text } from '@kanda-libs/ks-design-library';

import {
  type LenderConfigRow as Row,
  availableProviders,
  providerLabel,
} from './helpers';

export interface LenderConfigRowProps {
  index: number;
  isNew: boolean;
  configs: Row[];
  onDelete: (index: number) => void;
}

const LenderConfigRow: FunctionComponent<LenderConfigRowProps> = function ({
  index,
  isNew,
  configs,
  onDelete,
}) {
  return (
    <div className="flex flex-row items-end gap-x-3 border-b border-neutral-200 py-2">
      <div className="w-40">
        {isNew ? (
          <Field.Select
            name={`configs.${index}.provider`}
            label="Lender"
            options={availableProviders(configs, index)}
          />
        ) : (
          <div className="flex flex-col">
            <Text
              text="Lender"
              className="text-12-18-em text-neutral-700 w-full mb-2"
            />
            <div className="rounded flex w-full bg-neutral-000 border border-neutral-300 border-solid px-2 py-2.25 text-16-18 md:text-13-14 text-neutral-900 placeholder-neutral-600 mb-5">
              <Text
                className="text-16-18 md:text-13-14"
                text={providerLabel(configs[index]?.provider || '')}
              />
            </div>
          </div>
        )}
      </div>
      <div className="flex-1">
        <Field.Input
          name={`configs.${index}.xid`}
          label="User ID (editable)"
          placeholder="Enter the lender user id"
        />
      </div>
      <Button.Icon
        id={`staff-lender-config-delete-${index}`}
        icon="remove"
        onClick={() => onDelete(index)}
        className="mb-auto mt-5 text-red-200"
      />
    </div>
  );
};

export default LenderConfigRow;
